module.exports = __webpack_public_path__ + "img/ae80fa1.jpg";